import React from 'react';
import { connect } from 'react-redux';
import {Button,Paper,Divider,CssBaseline,TextField,Link,Grid,Box,Typography,Container} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { history } from "../components/helpers/History";
import {UserActions} from '../redux/actions/UserActions';

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class PatientSignUp extends React.Component {
    constructor(props) {
      super(props);
      const userid  = this.props.match && this.props.match.params ? this.props.match.params.userid:this.props.userId;
      this.state = {
          
              id:userid?userid:this.props.user.id,
              password: '',
              newPassword: '',
              confirmPassword : '',
          
          submitted: false
      };
  }


  componentDidMount() {
    if(this.state.id && this.state.id.length > 0){
      
    }else if(this.props.userId && this.props.userId.length > 0){
      this.setState({id:this.props.userId});
    }else {
      this.setState({id:this.props.user.id});
    }
    
  }

  render(){
    const classes = this.props.classes;
    const { registering  } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
        <Helmet>
          <title>Patient portal | Change password</title>
        </Helmet>
        <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Paper className={classes.paper}>
          <Formik 
              initialValues={{
                id:this.state.id,
                newPassword: this.state.newPassword,
                confirmPassword : this.state.confirmPassword
              }}

              validationSchema={Yup.object().shape({
                newPassword: Yup.string()
                  .max(30)
                  .matches(
                    /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
                    "Password must contain at least 8 characters, one uppercase, one number and one special case character"
                  )
                  .required("New Password is required"),
                confirmPassword: Yup.string()
                  .max(30)
                  .required("Confirm password is required")
                  .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
                })
              }
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({ submitted: true });
                  this.props.submit(values);
                }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit} className={classes.form}
                noValidate
                name="form"> 
                  <Box sx={{ mb: 3 }}>
                    <Typography color="textPrimary" align="center"
                    variant="h2" className={classes.typography}>
                      Update Password
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                      variant="outlined"
                      error={Boolean(touched.newPassword && errors.newPassword)}
                      helperText={touched.newPassword && errors.newPassword}
                      fullWidth
                      name="newPassword"
                      label="New Password"
                      type="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                      variant="outlined"
                      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                      helperText={touched.confirmPassword && errors.confirmPassword}
                      fullWidth
                      name="confirmPassword"
                      label="Confirm password"
                      type="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                    </Grid>
                  </Grid>
                  
                  
                  <div className={classes.buttons}>
                  <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={()=>{history.goBack();}}
                      >
                          Back
                      </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                  </div>
                  
                </form>
              )}
            </Formik>
            
        </Paper>
        </Container>
      </>
    );
  }
}


function mapStateToProps(state) {
  const  user  = state.authentication.user;
  return { user };
}

const mapDispatchToProps = (dispatch) => {
  return {
    submit: (user) => {
      dispatch(UserActions.updatePassword(user));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles,{ withTheme: true })(PatientSignUp));